<template>
  <!-- For Travelski Express: show only the terms link, no badge -->
  <div v-if="isTravelskiExpress">
    <TermsAndConditionsLink 
      :linkText="t('payments.termsAndConditions')"
      :custom-url="TRAVELSKI_EXPRESS_TERMS_URL"
    />
  </div>
  <!-- For regular bookings: show full payment condition with badge -->
  <BasePaymentCondition
    v-else
    border-class="orange-border"
    text-class="text-primary-orange"
  >
    <template #payment-condition-icon>
      <FixedPaymentIcon />
    </template>
    <template #payment-condition-type>
      {{ t('payments.fixedProduct') }}
    </template>
    <template #payment-condition__title__ref>
      {{ t('payments.fixedTitle') }}
    </template>
    <template #payment-condition-description>
      {{ t('payments.fixedDescription') }}
    </template>
  </BasePaymentCondition>
</template>

<script lang="ts" setup>
  // Vue
  import { computed, defineProps } from 'vue'

  // Icons
  import FixedPaymentIcon from '@/assets/FixedPaymentIcon.vue'

  // Components
  import BasePaymentCondition from './BasePaymentCondition.vue'
  import TermsAndConditionsLink from '@/components/common/TermsAndConditionsLink.vue'

  // Translations
  import { useI18n } from 'vue-i18n'
  const { t } = useI18n()

  // Config
  import { isTravelskiExpress as checkIsTravelskiExpress } from '@/config'
  import { TRAVELSKI_EXPRESS_TERMS_URL } from '@/config/termsAndConditions'

  interface Props {
    prestId: number
    liheId: number
    liheName?: string
    packageCode?: string
  }

  const props = defineProps<Props>()

  // Check if this is a Travelski Express booking
  const isTravelskiExpress = computed(() => {
    return checkIsTravelskiExpress(props.liheId, props.liheName, props.packageCode)
  })
</script>

<style scoped></style>
